"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeAssignmentsPath = void 0;
const isEmpty_1 = __importDefault(require("lodash/isEmpty"));
const removeAssignmentsPath = (URL) => {
    if ((0, isEmpty_1.default)(URL))
        return;
    const ASSIGNMENTS_API_PATH = 'assignments/api';
    let baseURL = URL;
    if (URL.includes(ASSIGNMENTS_API_PATH)) {
        baseURL = baseURL.replace(ASSIGNMENTS_API_PATH, '');
    }
    return baseURL;
};
exports.removeAssignmentsPath = removeAssignmentsPath;
//# sourceMappingURL=parse.helper.js.map